// 新手导引Cookie保存时间长度
export const LEARN_TIME = 9999999999;

// 退出需要清除Cookie的key值
// 不需要清空的Cookie的key值 ["learnStep"]
export const CLEAR_COOKIE_KEY = ["personMessage", "systemMessage", "emailTime", "phoneTime", "dateTime", "ALBtype", "isAlbSecond", "isAlbThird", "isThird", "isWCThird", "withdrawLastTime"];



